import { IconDeviceFloppy, IconRefresh } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
import { formatDate } from "@/lib/format-utils";

interface ShowMetadataProps {
    item: any;
}

export default function ShowMetadata({ item }: ShowMetadataProps) {
    const { t } = useTranslation();
    if (!item) return null;

    const createdBy = item.created_by || (item.created_by_id ? { id: item.created_by_id } : null);
    const updatedBy = item.updated_by || (item.updated_by_id ? { id: item.updated_by_id } : null);
    const owner = item.owner || (item.owner_id ? { id: item.owner_id } : null);
    const manager = item.manager || (item.manager_id ? { id: item.manager_id } : null);

    const createdByName = createdBy?.name || createdBy?.email || (createdBy?.id ? `#${createdBy.id}` : null);
    const updatedByName = updatedBy?.name || updatedBy?.email || (updatedBy?.id ? `#${updatedBy.id}` : null);
    const ownerName = owner?.name || owner?.email || (owner?.id ? `#${owner.id}` : null);
    const managerName = manager?.name || manager?.email || (manager?.id ? `#${manager.id}` : null);

    return (
        <div className="py-8">
            <div className="flex flex-wrap justify-center gap-x-6 gap-y-1 text-xs text-gray-400">
                {item.created_at && (
                    <div className="flex items-center gap-1">
                        <IconDeviceFloppy size={12} />
                        {formatDate(item.created_at)}
                    </div>
                )}
                {item.updated_at && (
                    <div className="flex items-center gap-1">
                        <IconRefresh size={12} />
                        {formatDate(item.updated_at)}
                    </div>
                )}
                {item.id && (
                    <div>
                        <span>#{item.id}</span>
                    </div>
                )}
                {createdByName && (
                    <div className="flex items-center gap-1">
                        <span>{t('created_by') || 'Created by'}: {createdByName}</span>
                        {createdBy?.id && createdBy.id !== 0 ? <span>| #{createdBy.id}</span> : null}
                    </div>
                )}
                {updatedByName && (
                    <div className="flex items-center gap-1">
                        <span>{t('updated_by') || 'Updated by'}: {updatedByName}</span>
                        {updatedBy?.id && updatedBy.id !== 0 ? <span>| #{updatedBy.id}</span> : null}
                    </div>
                )}
                {ownerName && (
                    <div className="flex items-center gap-1">
                        <span>{t('owner') || 'Owner'}: {ownerName}</span>
                    </div>
                )}
                {managerName && (
                    <div className="flex items-center gap-1">
                        <span>{t('manager') || 'Manager'}: {managerName}</span>
                    </div>
                )}
            </div>
        </div>
    );
}